import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  LoginForm,
  RegisterForm,
  ForgotPasswordForm,
  ResetPasswordForm,
} from "../dashboard/auth";
import { Home } from "../dashboard/home";
import { UsersManagement } from "../dashboard/users";
import { ModalAnswer } from "../dashboard/modal-answer";
import { PastModalAnswer } from "../dashboard/past-modal-answer";
import { Submissions, ResultDetails } from "../dashboard/submissions";
import { FlaggedEssays } from "../dashboard/flagged";
import { Profile } from "../dashboard/profile";
import { Layout } from "../component/layout";
import AuthRoute from "./AuthRoute";
import { PaymentHistory, ComingSoon, PlansManagement } from "../dashboard/payment";

const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <AuthRoute type="public">
            <LoginForm />
          </AuthRoute>
        }
      />
      <Route
        path="/register"
        element={
          <AuthRoute type="public">
            <RegisterForm />
          </AuthRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <AuthRoute type="public">
            <ForgotPasswordForm />
          </AuthRoute>
        }
      />
      <Route
        path="/reset-password"
        element={
          <AuthRoute type="public">
            <ResetPasswordForm />
          </AuthRoute>
        }
      />

      <Route
        path="/dashboard"
        element={
          <AuthRoute type="protected">
            <Layout>
              <Home />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/users"
        element={
          <AuthRoute type="protected">
            <Layout>
              <UsersManagement />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/modal-answer"
        element={
          <AuthRoute type="protected">
            <Layout>
              <ModalAnswer />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/past-modal-answer"
        element={
          <AuthRoute type="protected">
            <Layout>
              <PastModalAnswer />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/submissions"
        element={
          <AuthRoute type="protected">
            <Layout>
              <Submissions />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/submissions/:id"
        element={
          <AuthRoute type="protected">
            <Layout>
              <ResultDetails />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/flagged"
        element={
          <AuthRoute type="protected">
            <Layout>
              <FlaggedEssays />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <AuthRoute type="protected">
            <Layout>
              <Profile />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/payment-history"
        element={
          <AuthRoute type="protected">
            <Layout>
              <PaymentHistory />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <AuthRoute type="protected">
            <Layout>
              <ComingSoon />
            </Layout>
          </AuthRoute>
        }
      />
      <Route
        path="/plans"
        element={
          <AuthRoute type="protected">
            <Layout>
              <PlansManagement />
            </Layout>
          </AuthRoute>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
